<template>
    <div class="vx-card mb-5">
        <div class="vx-card__header">
            <div class="flex flex-wrap align-center">
                <div class="btn-group mr-5">
                    <h4>Functions</h4>
                </div>
                <div class="btn-group mr-5">
                    <vs-button size="small" icon="icon-copy" icon-pack="feather" ></vs-button>
                </div>
            </div>
        </div>
        <div class="vx-card__footer"></div>
    </div>
</template>

<script>
    export default {
        name: "InteractiveImage_Functions",
    }
</script>